import ReactDOM from 'react-dom/client'

import App from './App'

const Root = () => (
  
      <App />
)

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<Root/>);